// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCMmxQ89QA94-xznGTvJRUw4r8F4gWlGPI",
  authDomain: "nano-trading-copilot.firebaseapp.com",
  projectId: "nano-trading-copilot",
  storageBucket: "nano-trading-copilot.firebasestorage.app",
  messagingSenderId: "862420342655",
  appId: "1:862420342655:web:e1fb38024c912df093ac4a",
  measurementId: "G-K3XL0CFDN6"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
export default app;
